import type { ApiClient } from './client';
import type { AdminMetrics } from '@kolony/shared';

// The dashboard's client surface (D248). A thin typed wrapper with no state, exactly like
// `SocialApi` and `RatingApi`.
//
// The response TYPE is imported from shared rather than restated here — this document has
// some sixty fields across nine sections, and a hand-kept copy on the drawing side is a
// copy that can disagree with the measuring side (D198). Nothing else in `api/` needs that
// treatment; nothing else in `api/` is this shape.

export class AdminApi {
  constructor(private readonly api: ApiClient) {}

  /** `GET /admin/metrics`. 401 for a guest, 403 for a signed-in non-admin — both throw. */
  metrics(days: number): Promise<AdminMetrics> {
    return this.api.get<AdminMetrics>(`/admin/metrics?days=${String(Math.floor(days))}`);
  }
}
